import React from 'react';
import styled from 'styled-components';

import CountUp from 'react-countup';

import { Typography } from '@material-ui/core';

import MetisLineChart from '../../charts/MetisLineChart';

const Root = styled.div`
	max-width: 800px;

	h3 {
		margin-bottom: 40px;
		font-size: 20px;
		font-weight: bold;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}
`;

const ColorFont = styled.span`
	font-size: 16px;
	font-weight: bold;
	color: ${(props) => props.theme.palette.text.primary};
	background-image: ${(props) => props.theme.palette.text.gradient};
	background-clip: text;
	-webkit-background-clip: text;
	-moz-background-clip: text;
	-moz-text-fill-color: transparent;
	-webkit-text-fill-color: transparent;
`;

const EigenverbrauchPotentielleEinsparung = ({ data }) => {
	const ColorFontComponent = (
		<ColorFont>
			<CountUp
				end={data.co2savings}
				duration={3}
				separator="."
				suffix="t CO<sub>2</sub>"
			/>
		</ColorFont>
	);
	return (
		<Root>
			<Typography variant="h3">Ihre potentielle Einsparung</Typography>
			<Typography>
				Neben einer intelligenter Software und der maximalen Effizienz eines
				Energiespeichers sind wir auch in der Lage unseren Kunden attraktive
				Finanzierungsmodelle anzubieten. Entscheiden Sie auf der Grundlage
				präziser Daten was für sie eher in Frage kommt - Mieten oder Kaufen.
			</Typography>
			<Typography>
				Oder lassen Sie sich persönlich von unseren Experten beraten, wie Sie
				Ihren CO2 Fußabdruck jährlich um {ColorFontComponent} reduzieren.
			</Typography>
			<MetisLineChart data={data} />
		</Root>
	);
};

export default EigenverbrauchPotentielleEinsparung;
